module.exports = __webpack_public_path__ + "assets/img/images_a.ac7bdad0.png";